var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.92593 0C2.65313 0 0 2.65313 0 5.92593C0 8.37798 1.48929 10.4822 3.61268 11.3834C3.34826 10.7068 3.20312 9.97043 3.20312 9.20019V8.4002C3.20312 5.08649 5.88942 2.40019 9.20312 2.40019C9.77459 2.40019 10.3274 2.48009 10.851 2.62931C9.78753 1.04367 7.97861 0 5.92593 0Z",
    fill: "#A16207"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.19922,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#A16207"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleIcon);
export default __webpack_public_path__ + "static/media/double-icon.979358ddf4fec24c4e4c8096194f5039.svg";
export { ForwardRef as ReactComponent };